// نظام الثيمات.
//
// لماذا أُعيد بناؤه: النسخة السابقة كانت سبعة ثيمات كلها بين 3% و6% سطوع
// (أي سوداء فعلياً)، وكل ثيم يحمل ~15 سلسلة Tailwind تُمرَّر يدوياً إلى كل
// مكوّن. تغيير لون واحد كان يعني تعديل سبعة ملفات.
//
// الآن: متغيّرات CSS على :root. المكوّنات تستخدم أسماء دلالية
// (bg-paper، text-ink) ولا تعرف شيئاً عن الثيم المطبَّق.
//
// اللوحة مبنية على ألوان تذهيب المخطوطات الإسلامية — اللازورد والرَّق
// وماء الذهب — لا على الأخضر/الذهبي الذي تتشابه فيه كل تطبيقات القرآن.

/**
 * كل ثيم يعرّف نفس المفاتيح. القيم خام (R G B) لتعمل مع
 * صيغة Tailwind اللونية ‎rgb(var(--x) / <alpha-value>)‎.
 */
export const THEMES = [
  {
    id: 'noor',
    name: 'نور',
    hint: 'لازورد ورَق',
    mode: 'light',
    group: 'day',
    swatch: ['#FBF7F0', '#2E4B8F', '#B8862F'],
    tokens: {
      paper: '251 247 240',
      surface: '255 253 249',
      surfaceAlt: '244 239 229',
      ink: '27 42 74',
      inkMuted: '88 99 122',
      line: '208 198 180',
      primary: '46 75 143',
      primaryInk: '255 255 255',
      secondary: '184 134 47',
      live: '194 67 46',
      glow: '46 75 143',
    },
  },
  {
    id: 'duha',
    name: 'ضحى',
    hint: 'ضوء الصباح',
    mode: 'light',
    group: 'day',
    swatch: ['#FFFBF2', '#C2851B', '#7A5B12'],
    tokens: {
      paper: '255 251 242',
      surface: '255 255 252',
      surfaceAlt: '250 242 226',
      ink: '61 46 16',
      inkMuted: '110 92 58',
      line: '222 207 178',
      primary: '146 96 12',
      primaryInk: '255 255 255',
      secondary: '122 91 18',
      live: '190 70 40',
      glow: '236 187 84',
    },
  },
  {
    id: 'sama',
    name: 'سماء',
    hint: 'صفاء نهاري',
    mode: 'light',
    group: 'day',
    swatch: ['#F4FAFC', '#0E7490', '#0F766E'],
    tokens: {
      paper: '244 250 252',
      surface: '255 255 255',
      surfaceAlt: '229 242 247',
      ink: '12 47 61',
      inkMuted: '70 99 111',
      line: '190 214 224',
      primary: '14 116 144',
      primaryInk: '255 255 255',
      secondary: '15 118 110',
      live: '200 62 62',
      glow: '56 189 213',
    },
  },
  {
    id: 'zaytoon',
    name: 'زيتون',
    hint: 'أخضر هادئ',
    mode: 'light',
    group: 'day',
    swatch: ['#F7F8F1', '#4A6B3C', '#8A6E2F'],
    tokens: {
      paper: '247 248 241',
      surface: '253 254 249',
      surfaceAlt: '237 240 226',
      ink: '32 43 26',
      inkMuted: '90 101 80',
      line: '203 210 186',
      primary: '74 107 60',
      primaryInk: '255 255 255',
      secondary: '138 110 47',
      live: '186 71 48',
      glow: '124 160 96',
    },
  },
  {
    id: 'ward',
    name: 'ورد',
    hint: 'دافئ وردي',
    mode: 'light',
    group: 'day',
    swatch: ['#FDF6F5', '#9C3B52', '#7A4B86'],
    tokens: {
      paper: '253 246 245',
      surface: '255 252 251',
      surfaceAlt: '248 234 233',
      ink: '58 28 35',
      inkMuted: '118 88 94',
      line: '222 200 199',
      primary: '156 59 82',
      primaryInk: '255 255 255',
      secondary: '122 75 134',
      live: '183 58 58',
      glow: '212 132 152',
    },
  },
  {
    id: 'layl',
    name: 'ليل',
    hint: 'نيلي للقراءة ليلاً',
    mode: 'dark',
    group: 'night',
    swatch: ['#121A2E', '#8AA7E8', '#D8B45C'],
    tokens: {
      paper: '18 26 46',
      surface: '26 36 60',
      surfaceAlt: '35 47 76',
      ink: '226 232 245',
      inkMuted: '148 161 189',
      line: '48 62 94',
      primary: '138 167 232',
      primaryInk: '15 22 40',
      secondary: '216 180 92',
      live: '232 106 92',
      glow: '92 124 200',
    },
  },
  {
    id: 'mihrab',
    name: 'محراب',
    hint: 'بنّي دافئ وذهب',
    mode: 'dark',
    group: 'night',
    swatch: ['#1E1710', '#D9A441', '#9AB08A'],
    tokens: {
      paper: '30 23 16',
      surface: '43 33 23',
      surfaceAlt: '56 43 30',
      ink: '241 234 222',
      inkMuted: '177 163 143',
      line: '74 58 41',
      primary: '217 164 65',
      primaryInk: '34 25 14',
      secondary: '154 176 138',
      live: '224 106 84',
      glow: '180 132 56',
    },
  },
  {
    id: 'raq',
    name: 'رَق',
    hint: 'ورق المخطوطات للقراءة الطويلة',
    mode: 'light',
    group: 'day',
    swatch: ['#F6EFE1', '#804C1C', '#465A78'],
    tokens: {
      paper: '246 239 225',
      surface: '251 246 236',
      surfaceAlt: '238 228 208',
      ink: '52 38 22',
      inkMuted: '102 82 56',
      line: '210 194 165',
      primary: '128 76 28',
      primaryInk: '255 255 255',
      secondary: '70 90 120',
      live: '170 56 36',
      glow: '196 140 70',
    },
  },
  {
    id: 'fayruz',
    name: 'فيروز',
    hint: 'زليج أزرق مخضرّ',
    mode: 'light',
    group: 'day',
    swatch: ['#F0F8F7', '#006D77', '#A8701E'],
    tokens: {
      paper: '240 248 247',
      surface: '255 255 255',
      surfaceAlt: '224 240 238',
      ink: '14 44 52',
      inkMuted: '62 90 96',
      line: '184 214 212',
      primary: '0 104 114',
      primaryInk: '255 255 255',
      secondary: '150 98 22',
      live: '190 58 46',
      glow: '64 186 190',
    },
  },
  {
    id: 'kiswa',
    name: 'كسوة',
    hint: 'أسود وتطريز ذهبي',
    mode: 'dark',
    group: 'night',
    swatch: ['#0E0D0B', '#D6AC52', '#A0967D'],
    tokens: {
      paper: '14 13 11',
      surface: '26 24 20',
      surfaceAlt: '38 35 29',
      ink: '240 232 214',
      inkMuted: '180 168 144',
      line: '64 58 47',
      primary: '214 172 82',
      primaryInk: '20 16 8',
      secondary: '160 150 125',
      live: '232 104 84',
      glow: '200 150 60',
    },
  },
  {
    id: 'qubba',
    name: 'قبّة',
    hint: 'أخضر عميق وذهب',
    mode: 'dark',
    group: 'night',
    swatch: ['#0C1E1A', '#DEB862', '#78C8AA'],
    tokens: {
      paper: '12 30 26',
      surface: '20 42 37',
      surfaceAlt: '28 55 48',
      ink: '228 240 234',
      inkMuted: '152 182 172',
      line: '44 76 67',
      primary: '222 184 98',
      primaryInk: '18 26 20',
      secondary: '120 200 170',
      live: '236 112 92',
      glow: '90 160 130',
    },
  },
  {
    id: 'ghasaq',
    name: 'غسق',
    hint: 'بنفسجي ما بعد المغرب',
    mode: 'dark',
    group: 'night',
    swatch: ['#1E1424', '#ECA078', '#AA96DC'],
    tokens: {
      paper: '30 20 36',
      surface: '42 30 50',
      surfaceAlt: '55 40 64',
      ink: '240 230 242',
      inkMuted: '184 164 190',
      line: '76 60 86',
      primary: '236 160 120',
      primaryInk: '36 20 20',
      secondary: '170 150 220',
      live: '240 112 112',
      glow: '200 120 140',
    },
  },
  {
    id: 'wudooh',
    name: 'وضوح',
    hint: 'تباين عالٍ للنظر الضعيف',
    mode: 'light',
    group: 'contrast',
    swatch: ['#FFFFFF', '#18348C', '#0A0E16'],
    tokens: {
      paper: '255 255 255',
      surface: '255 255 255',
      surfaceAlt: '238 241 246',
      ink: '10 14 22',
      inkMuted: '52 58 72',
      line: '130 138 152',
      primary: '24 52 140',
      primaryInk: '255 255 255',
      secondary: '110 72 0',
      live: '176 18 18',
      glow: '24 52 140',
    },
  },
  {
    id: 'wudoohLayl',
    name: 'وضوح ليلي',
    hint: 'أسود خالص وأصفر',
    mode: 'dark',
    group: 'contrast',
    swatch: ['#000000', '#FFD666', '#FFFFFF'],
    tokens: {
      paper: '0 0 0',
      surface: '16 16 18',
      surfaceAlt: '30 30 34',
      ink: '255 255 255',
      inkMuted: '206 206 212',
      line: '120 120 128',
      primary: '255 214 102',
      primaryInk: '0 0 0',
      secondary: '150 200 255',
      live: '255 122 110',
      glow: '255 214 102',
    },
  },
];

export const THEME_GROUPS = [
  { id: 'day', title: 'نهاري' },
  { id: 'night', title: 'ليلي' },
  { id: 'contrast', title: 'عالي الوضوح' },
];

export const DEFAULT_THEME_ID = 'noor';

export const findTheme = (id) => THEMES.find((t) => t.id === id) ?? THEMES[0];

/**
 * الثيم التلقائي: يتبع وقت الصلاة الحالي.
 *
 * هذا هو سبب وجود نظام الثيمات أصلاً — اللون يخبرك أين أنت من اليوم،
 * فالتطبيق يشرق مع الضحى ويهدأ مع العشاء دون أن تلمس شيئاً.
 */
export const THEME_BY_PRAYER = {
  fajr: 'sama',
  sunrise: 'duha',
  dhuhr: 'noor',
  asr: 'duha',
  maghrib: 'ward',
  isha: 'layl',
  none: 'layl',
};

/**
 * يحدد الثيم التلقائي المناسب بناءً على الصلاة الحالية أو ساعة اليوم.
 */
export function getAutoThemeId(prayerPeriod) {
  if (prayerPeriod && THEME_BY_PRAYER[prayerPeriod]) {
    return THEME_BY_PRAYER[prayerPeriod];
  }
  const h = new Date().getHours();
  if (h >= 4 && h < 6) return 'sama';
  if (h >= 6 && h < 11) return 'duha';
  if (h >= 11 && h < 15) return 'noor';
  if (h >= 15 && h < 18) return 'duha';
  if (h >= 18 && h < 20) return 'ward';
  return 'layl';
}

/**
 * جدول الثيم التلقائي: متى يبدأ كل ثيم في الأمس واليوم والغد.
 *
 * الإقلاع لا ينتظر حساب المواقيت: سكربت index.html وأندرويد يقرآن هذا
 * الجدول فيعرفان ثيم اللحظة الحاضرة. كانا يعرضان آخر ثيم رُئي في الجلسة
 * السابقة، فإن تغيّر وقت الصلاة منذها ومض الثيم القديم ثم تبدّل.
 *
 * @param {Array<Record<string, Date>>} days مواقيت الأمس واليوم والغد
 * @returns {Array<[number, string, string, string]>} [بداية, معرّف, لون الورق, الوضع]
 */
export function buildThemeSchedule(days) {
  const keys = ['fajr', 'sunrise', 'dhuhr', 'asr', 'maghrib', 'isha'];
  const entries = [];
  days.forEach((times, dayIndex) => {
    keys.forEach((key) => {
      // من الأمس يكفي العشاء: هو ثيم ما قبل فجر اليوم
      if (dayIndex === 0 && key !== 'isha') return;
      const at = times?.[key];
      if (!(at instanceof Date) || Number.isNaN(at.getTime())) return;
      const theme = findTheme(THEME_BY_PRAYER[key]);
      entries.push([at.getTime(), theme.id, paperHex(theme), theme.mode]);
    });
  });
  return entries.sort((a, b) => a[0] - b[0]);
}

function paperHex(theme) {
  return `#${theme.tokens.paper
    .split(' ')
    .map((n) => Number(n).toString(16).padStart(2, '0'))
    .join('')}`;
}

/** يطبّق رموز الثيم على عنصر الجذر. */
export function applyTheme(theme) {
  const root = document.documentElement;
  Object.entries(theme.tokens).forEach(([key, value]) => {
    root.style.setProperty(`--c-${key}`, value);
  });
  root.dataset.mode = theme.mode;
  root.dataset.theme = theme.id;
  root.style.backgroundColor = `rgb(${theme.tokens.paper})`;
  root.style.color = `rgb(${theme.tokens.ink})`;

  try {
    localStorage.setItem('moslam_theme_active', theme.id);
    // سكربت الإقلاع في index.html يطبّق هذه قبل أول رسم، لأي ثيم كان
    localStorage.setItem('moslam_theme_tokens', JSON.stringify({ id: theme.id, mode: theme.mode, tokens: theme.tokens }));
  } catch {}

  // لون شريط المتصفح/النظام يتبع الورق
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', `rgb(${theme.tokens.paper})`);
}
